import { useContext } from "react";
import { SearchBar, SearchBarProps } from "../../search-bar";
import { DrawerSelectContext } from "../drawer-select.context";

export type DrawerSelectSearchInputProps = Readonly<SearchBarProps>;

export function DrawerSelectSearchInput({
  ...props
}: DrawerSelectSearchInputProps) {
  const { query, handleQueryValueChange } = useContext(DrawerSelectContext);

  return (
    <SearchBar value={query} onChange={handleQueryValueChange} {...props} />
  );
}
